
module.exports = function()
{
    this.venues = [];
    this.tags = [];
    this.guests = [];
    this.freebieReasons = [];
    this.kitchenStationProfiles = [];
}